export const PathNamekRoutes = {
  EMPLOYEE: "asociados",
  PROGRAMS: "programs",
  PAYMENTSETTLEMENT: "paymentSettlement",
  RENDITION: "rendition",
  CATEGORIES: "categories",
  CONFIGURATION: "configuration",

  MACROGENERATORS: "macroGenerators",
  COLLECTIONS: "collections",

  PRESENTEEISM: {
    EMPLOYEES: "empleados",
    ASSOCIATES: "asociados",
    RUTAS: "rutas",
    REPORT: "reporte",
  },

  POWERBI: {
    DASHBOARD: "dashboard",
  },

  UNAUTHORIZED: "unauthorized",
  LOGOUT: "logout",
  LOGIN: "login",
  WELCOME: "",
};
